import { render, staticRenderFns } from "./PanelSelector.vue?vue&type=template&id=e574e57c&scoped=true"
import script from "./PanelSelector.vue?vue&type=script&lang=js"
export * from "./PanelSelector.vue?vue&type=script&lang=js"
import style0 from "./PanelSelector.vue?vue&type=style&index=0&id=e574e57c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e574e57c",
  null
  
)

export default component.exports